import {UI} from "stem-core/ui/UIBase";
import {registerStyle, styleRule, StyleSheet} from "stem-core/ui/Style";
import {isSmallScreen} from "../../Utils";
import {ExclamationTriangleIcon} from "../../../core/ui/SVGElements.jsx";
import type {UIChild} from "../../../stem-core/ui/UIBase";


class ErrorPanelStyle extends StyleSheet {
    @styleRule
    container = {
        textAlign: "center",
        fontSize: this.themeProps.FONT_SIZE_NORMAL,
    };

    @styleRule
    icon = {
        margin: () => isSmallScreen() ? "70px auto" : "0px auto 12px",
    };
}

interface ErrorPanelOptions {
    errorMessage?: UIChild;
}

@registerStyle(ErrorPanelStyle)
export class ErrorPanel extends UI.Element<ErrorPanelOptions> {
    render() {
        const {styleSheet} = this;
        return [
            <ExclamationTriangleIcon className={styleSheet.icon}/>,
            <div>{this.options.errorMessage}</div>
        ];
    }
}

